export default {
  EVENT_SETTINGS_UPDATED: 'Die Event-Einstellungen wurden erfolgreich aktualisiert!',
  DAILY_REPORTS_ENABLED: 'Tägliche Berichte aktiviert',
  EVENT_SETTINGS: 'Ereigniseinstellungen',
  ARCHIVAL_DAYS: 'Archivtage',
  EVENT_ARCHIVAL_DATE: 'Die Veranstaltung wird am archiviert '
}
